export enum Download_Log_FIN {
    D_FILE_MANAGERC = 1,
    D_LAST_VA_IN_FM = 2,
    D_SPECIFIC_TASK = 3,
    D_REPORT_STRUCT = 4,
    D_REPORT_LISTIN = 5,
    D_FILE_ADSEARCH = 6,
    D_VERSION_HISTO = 7,
    D_LAST_VERSIONA = 8,
    D_ANNEX_LAST_VA = 9,
    D_ANNEXE_FILE_M = 10,
    D_ANN_VERS_H_FI = 11,
    D_ANN_VERS_H_AN = 12,
    D_PRINT_FORMATF = 13
}

export enum Report_Download_FIN {
    PDF = 1,
    XSLX = 2
}
